import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import ProductProp, { PRODUCT_STATIC_TAB } from '../propTypes/productProp';
import CustomTabTitle from './customTabs/CustomTabTitle';
import CustomTabContent from './customTabs/CustomTabContent';

function ShopProductTabs({ t, product }) {
  const { customTabs = [] } = product;
  const [activeTab, setActiveTab] = useState(PRODUCT_STATIC_TAB.DESCRIPTION);

  const activeTabs = useMemo(() => {
    const staticTabs = Object.values(PRODUCT_STATIC_TAB).map(staticTab => ({
      _id: staticTab,
      name: t(`shop.product.${staticTab}`),
    }));
    return [...staticTabs, ...customTabs];
  }, [customTabs]);

  const handleTabChange = useCallback(
    newActiveTab => setActiveTab(newActiveTab),
    [setActiveTab],
  );

  return (
    <div className="m-portlet--rounded m-portlet--rounded-force m--margin-top-10 m--margin-bottom-10 shop-product">
      <div id="container-body" className="m-portlet__body">
        <div className="row no-padding">
          <div className="col-lg-12 col-md-12">
            <div className="m-portlet m-portlet--tabs customTabs-container">
              <CustomTabTitle
                activeTabs={activeTabs}
                activeTab={activeTab}
                onTabChange={handleTabChange}
              />
              <CustomTabContent
                product={product}
                activeTabs={activeTabs}
                activeTab={activeTab}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ShopProductTabs.propTypes = {
  t: PropTypes.func.isRequired,
  product: PropTypes.shape(ProductProp.propType).isRequired,
};

export default translate(ShopProductTabs);
